import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { Country } from '@core/locations/models/country.interface';

@Injectable({
  providedIn: 'root',
})
export class CountriesService {
  private readonly httpClient = inject(HttpClient);

  getCountries(): Observable<Country[]> {
    const url = 'api/v1/lookups/countries';

    return this.httpClient.get<Country[]>(environment.portalApiUrl + url);
  }
}
